import { formatScreenshotTimestamp } from '../utils/date';

export default ({ headers, baseUrl, bankId, caseInfo }) => ({
  getQuestions: () => ({
    uri:
      `${baseUrl}/banks/${bankId}/cases/bsap` +
      `/${caseInfo.subType}/${caseInfo.id}/tasks/verify/actions/challenge`,
    method: 'PUT',
    headers: {
      ...headers,
      'x-bpi-version': '1.0.0'
    }
  }),
  submitAnswers: answers => ({
    uri:
      `${baseUrl}/banks/${bankId}/cases/bsap` +
      `/${caseInfo.subType}/${caseInfo.id}/tasks/verify/actions/submit`,
    method: 'PUT',
    body: JSON.stringify({
      challenges: answers
    }),
    headers: {
      ...headers,
      'x-bpi-version': '1.0.0'
    }
  }),
  attachEvidence: (context, screenshot) => ({
    uri: `${baseUrl}/banks/${bankId}/cases/bsap/${caseInfo.subType}/${caseInfo.id}/evidence`,
    method: 'POST',
    body: JSON.stringify({
      context,
      capture_timestamp: formatScreenshotTimestamp(),
      image: {
        mime_type: 'image/jpeg',
        data: [screenshot]
      }
    }),
    headers: {
      ...headers,
      'x-bpi-version': '1.0.0'
    }
  })
});
